module.exports = __webpack_public_path__ + "img/alex-book-closed.d6594b04.png";